import { SurveyQuestionTypes } from '../../../../shared/surveys'
import Bool from '../../../public/assets/img/bool.svg'
import ChooseOne from '../../../public/assets/img/chooseone.svg'
import MultipleChoice from '../../../public/assets/img/multiplechoice.svg'
import Rating from '../../../public/assets/img/rating.svg'
import Text from '../../../public/assets/img/text.svg'
import Info from '../../../public/assets/img/info.svg'
import { IAggregatedItem } from '../../components/common/aggregated-results/AggregatedResult'
import { ISurvey, ISurveyQuestion } from './types'

export const getSurveyTypeImage = (questionType) => {
  switch (questionType) {
    case SurveyQuestionTypes.BOOL:
      return Bool
    case SurveyQuestionTypes.CHOOSE_ONE:
      return ChooseOne
    case SurveyQuestionTypes.MULTIPLE_CHOICE:
      return MultipleChoice
    case SurveyQuestionTypes.RATING:
      return Rating
    case SurveyQuestionTypes.TEXT:
      return Text
    case SurveyQuestionTypes.INFO:
      return Info
    default:
      return null
  }
}

export const getSurveyTypeName = (questionType) => {
  switch (questionType) {
    case SurveyQuestionTypes.BOOL:
      return 'True/False'
    case SurveyQuestionTypes.CHOOSE_ONE:
      return 'Choose one'
    case SurveyQuestionTypes.MULTIPLE_CHOICE:
      return 'Multiple choice'
    case SurveyQuestionTypes.RATING:
      return 'Rating'
    case SurveyQuestionTypes.TEXT:
      return 'Text'
    case SurveyQuestionTypes.INFO:
      return 'Info'
    default:
      return null
  }
}

export const getFormattedOptionStats = (question) => {
  const answers = question.aggregatedAnswers
  const formattedOptions: IAggregatedItem[] = []

  question.content.options.forEach((option, index) => {
    const item = {
      count: 0
    } as IAggregatedItem
    item.label = option.label
    if (answers.find((answer) => answer.value === option.id)) {
      item.count = answers.find((answer) => answer.value === option.id).count
    }

    item.value = null
    if (question.type === SurveyQuestionTypes.RATING) {
      item.value = question.content.options.length - index
    }
    formattedOptions.push(item)
  })

  return formattedOptions
}

export const countWidthRate = (partial, total) => {
  if (total === 0) {
    return '0%'
  }
  return `${Math.round((partial / total) * 100)}%`
}

export const isSurveyEditable = (survey: ISurvey) =>
  !(survey.published_at || survey.completed_at)

export const getIndexOfNonInfoQuestion = (
  questions: ISurveyQuestion[],
  index: number | undefined
) => {
  return filterInfoQuestions(questions.slice(0, index)).length
}

export const filterInfoQuestions = (questions: ISurveyQuestion[]) => {
  return questions.filter(function (question) {
    return question.type !== SurveyQuestionTypes.INFO && question
  })
}
